import { atomWithQuery } from "jotai-tanstack-query";
import { syncUser } from "../../apis/auth";
import { Storage, atomWithLocalStorage } from "../../storage";

export const authAtom = atomWithQuery(() => ({
  queryKey: ["userSync"],
  queryFn: async () => {
    const userString = Storage.getString("currentUser");
    const user = userString ? JSON.parse(userString) : null;
    if (!user) return null;
    const response = await syncUser(user.accessToken);
    if (response.status === "success") {
      return { ...response.data, accessToken: user.accessToken };
    } else {
      Storage.delete("currentUser");
      return null;
    }
  },
   // Force stale after 24 hours
  // staleTime: 1000 * 60 * 60 * 24,
  // staleTime: 0,  // Force immediate stale
}));

export const termsAndConditionsAgreedLocallyAtom = atomWithLocalStorage<boolean>(
  "termsAndConditionsAgreedLocally",
  false
);

export const remindLocationAtom = atomWithLocalStorage<boolean>(
  "remindLocation",
  false
);
